// src/pages/customer/customerpanel/WishlistPanel.jsx
import React from 'react';
import WishlistCard from '../customerwidgets/WishlistCard';

export default function WishlistPanel({ wishlist = [], loading, onRemove }) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-black text-on-surface">My Wishlist</h2>
        <p className="text-sm text-secondary mt-1">Animals you've saved for later.</p>
      </div>

      {loading ? (
        <p className="text-sm text-secondary text-center py-8">Loading wishlist…</p>
      ) : wishlist.length === 0 ? (
        <div className="bg-white rounded-2xl p-10 shadow-sm border border-outline-variant/10
                        flex flex-col items-center justify-center text-center gap-3">
          <span className="material-symbols-outlined text-[48px] text-outline">favorite</span>
          <p className="text-lg font-black text-on-surface">Wishlist is empty</p>
          <p className="text-sm text-secondary max-w-xs">
            Save animals you're interested in to track them here.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {wishlist.map(item => (
            <WishlistCard key={item.id} item={item} onRemove={onRemove} />
          ))}
        </div>
      )}
    </div>
  );
}
